import { PAGE_LOADING, PAGE_LOADED } from '../page_details/actiontypes'
import * as actionTypes from './actiontypes'
import * as API from './api'
import { log } from '../../config/utils'

export const updateKpiState = (payload, path) => {
  return {
    type: actionTypes.UPDATE_KPI_STATE,
    payload,
    path
  }
}

export const fetchKpiFilterAndData = (data, callback) => {
  return dispatch => {
    dispatch({
      type: PAGE_LOADING,
      payload: "kpi loading"
    })
    API.fetchKpiFilterAndData(data, (err, res) => {
      log('fetch kpi response:', res)
      dispatch({
        type: PAGE_LOADED,
      })
      if (!err && res && res.data) {
        if (callback) callback()
        dispatch({
          type: actionTypes.KPI_FILTER_AND_DATA_LOADED,
          payload: res.data
        })
      }
    })
  }
}

export const getAgentLiveKpis = data => {
  return dispatch => {
    API.getAgentLiveKpis(data, (err, res) => {
      log('getAgentLiveKpis res', res)
      if (!err && res && res.data && res.data.agentKpis)
        dispatch(updateKpiState(res.data.agentKpis, 'agent_live_kpis'))
    })
  }
}



// WEBPACK FOOTER //
// ./src/data/redux/kpi_details/actions.js